import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import { ReturnItem } from 'returnCenter-api';

type QuantityRequestedCellProps = {
    item: ReturnItem;
    itemId?: number | string;
};

const QuantityRequestedCell = ({ item, itemId }: QuantityRequestedCellProps) => {
    return (
        <Flex align="center" justify="center" $grow={1} key={itemId}>
            <Text fontSize={12} bold as="span">
                {item.quantityRequested ?? 0}
            </Text>
        </Flex>
    );
};

export default QuantityRequestedCell;
